import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';

const ChatPageContext = createContext();

/**
 * Provider that holds the current page's contextual state for the chat widget.
 * Each page updates this via useChatPageEffect so the widget can pass rich
 * context to the AI agent with every message.
 */
export function ChatPageProvider({ children }) {
    const [pageState, setPageState] = useState({});

    return (
        <ChatPageContext.Provider value={{ pageState, setPageState }}>
            {children}
        </ChatPageContext.Provider>
    );
}

ChatPageProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

/**
 * Hook to access the current chat page context.
 * - Pages call setPageState() to publish their state.
 * - The chat widget reads pageState to include in messages.
 */
export function useChatPageState() {
    return useContext(ChatPageContext);
}
